import { useState, useEffect } from 'react'

const CONSENT_KEY = 'ntc_cookie_consent'

export function CookieConsent() {
  const [visible, setVisible] = useState(false)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    const mountTimer = setTimeout(() => setMounted(true), 3000)
    return () => clearTimeout(mountTimer)
  }, [])

  useEffect(() => {
    if (!mounted) return
    const consent = localStorage.getItem(CONSENT_KEY)
    if (!consent) setVisible(true)
    if (consent === 'accepted') fireConsent()
  }, [mounted])

  const fireConsent = () => {
    if (typeof window.gtag !== 'function') return
    window.gtag('consent', 'update', {
      analytics_storage: 'granted',
      ad_storage: 'denied', // Keep denied until Google Ads is configured
    })
    window.gtag('event', 'page_view')
  }

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted')
    fireConsent()
    setVisible(false)
  }

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined')
    setVisible(false)
  }

  if (!mounted || !visible) return null

  return (
    <div style={{
      position: 'fixed',
      bottom: 24,
      left: 24,
      right: 24,
      maxWidth: 480,
      background: 'var(--bg-3)',
      border: '1px solid rgba(78,125,233,0.25)',
      borderRadius: 8,
      padding: '20px 24px',
      zIndex: 9998,
      boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
      willChange: 'transform',
      transform: 'translateZ(0)',
    }}>
      <p style={{
        fontSize: 13,
        lineHeight: 1.6,
        color: 'var(--white-dim)',
        marginBottom: 16,
      }}>
        We use cookies to understand how visitors use our site and to improve
        your experience. We do not sell your data.
      </p>
      <div style={{ display: 'flex', gap: 12 }}>
        <button
          onClick={accept}
          style={{
            background: 'var(--accent)',
            color: 'var(--white)',
            border: 'none',
            borderRadius: 4,
            padding: '8px 20px',
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: 'Barlow, sans-serif',
          }}
        >
          Accept
        </button>
        <button
          onClick={decline}
          style={{
            background: 'transparent',
            color: 'var(--white-dim)',
            border: '1px solid rgba(238,240,245,0.2)',
            borderRadius: 4,
            padding: '8px 20px',
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: 'Barlow, sans-serif',
          }}
        >
          Decline
        </button>
      </div>
    </div>
  )
}
